import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { DateValue } from '@jutro/components';
import { ServiceManager } from '@jutro/legacy/services';
import { MLRiskAnalysisService } from 'ml-services-common-react';
import metadata from './MLRatingFactorPriorCarrierComponent.metadata.json5';
import './MLRatingFactorPriorCarrierComponent.messages.js';

const MLRatingFactorPriorCarrierComponent = (props) => {
    const { jobOrPolicyNumber, isQuote, isPolicy, isPersonalAuto, isPersonalUmbrella, styles, authHeader } = props;

    const localeService = ServiceManager.getService('locale-service');
    const localCurrency = localeService.getDefaultCurrencySymbol();

    const [priorCarrier, setPriorCarrier] = useState({});   
    const [monthsOfContinuousInsurance, setMonthsOfContinuousInsurance] = useState(undefined);   

    const updatePriorCarrier = (data) => {
        // setPriorCarrier({
        //     carrierName: 'Allstate',
        //     policyNumber: 'A021129535',
        //     policyStatus: 'Expired',
        //     biLimit: '10000/200000',
        //     pdLimit: '200000',
        //     timeWithPriorCarrier: '5 years',
        //     lastCancelDate: {
        //         year: 2012,
        //         month: 10,
        //         day: 25
        //     }
        // });
        if (isPersonalAuto) {
            const currentCarrier = data.lobs.personalAuto.priorCarrier;
            const allCarriers = [currentCarrier].concat(data.lobs.personalAuto.otherPriorCarriers)
            setPriorCarrier(!_.isEmpty(currentCarrier) ? allCarriers : []);
            setMonthsOfContinuousInsurance(data.lobs.personalAuto.monthsOfContinuousPriorInsurance);
        } else if (isPersonalUmbrella) {
            const _priorCarrier = data.lobs.personalUmbrella.priorCarrier;
            setPriorCarrier(!_.isEmpty(_priorCarrier) ? [_priorCarrier] : []);
        }
    };
    
    const getAndSetPriorCarrierBySubmissionNumber = (submissionNumber) => {
        if (_.isEmpty(priorCarrier)) {
            const promise = MLRiskAnalysisService.getRAPriorCarrierMLByJobNumber(submissionNumber, authHeader);
            promise.then((data) => {
                updatePriorCarrier(data);
            });
        }
    };

    const getAndSetPriorCarrierByPolicyNumber = (policyNumber) => {
        const promise = MLRiskAnalysisService.getRAPriorCarrierMLByPolicyNumber(policyNumber, authHeader);
        promise.then((data) => {
            updatePriorCarrier(data);
        });
    };    

    useEffect(() => {
        if (isQuote) {
            getAndSetPriorCarrierBySubmissionNumber(jobOrPolicyNumber);
        } else if (isPolicy) {
            getAndSetPriorCarrierByPolicyNumber(jobOrPolicyNumber);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getPriorCarrierTableOverrides = () => {
        const getCellPolicyNumber = (rowData) => {
            return rowData.policyNumber;
        };
    
        const getCellPolicyStatus = (rowData) => {
            return rowData.policyStatus;
        };
    
        const getCellBILimit = (rowData) => {
            return `${localCurrency}${rowData.biLimit}`;
        };
    
        const getCellPDLimit = (rowData) => {
            return `${localCurrency}${rowData.pdLimit}`;
        };

        const getCellTimeWithPriorCarrier = (rowData) => {
            return rowData.timeWithPriorCarrier;
        };

        const getCellLastCancelDate = (rowData) => {
            return <DateValue displayFormat='vshort' value={rowData.lastCancelDate} />;
        }

        const getCellCarrierName = (rowData) => {
            return rowData.carrierName
        };

        return {
            policyNumberColumn: {
                renderCell: getCellPolicyNumber
            },
            policyStatusColumn: {
                renderCell: getCellPolicyStatus
            },
            biLimitColumn: {
                renderCell: getCellBILimit
            },
            pdLimitColumn: {
                renderCell: getCellPDLimit
            },
            timeWithPriorCarrierColumn: {
                renderCell: getCellTimeWithPriorCarrier
            },
            lastCancelDateColumn: {
                renderCell: getCellLastCancelDate
            },
            carrierColumn: {
                renderCell: getCellCarrierName
            }
        }
    }

    const overrideProps = {
        priorCarrierContinuousCoverageContainer: {
            visible: isPersonalAuto && !!monthsOfContinuousInsurance
        },
        continuousMonthsContent: { 
            content: monthsOfContinuousInsurance
        },
        priorCarrierTable: {
            data: !_.isEmpty(priorCarrier) ? priorCarrier : []
        },
        ...getPriorCarrierTableOverrides()
    }

    const resolvers = {
        resolveClassNameMap: styles
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
        />    
    )
};

MLRatingFactorPriorCarrierComponent.propTypes = {
    jobOrPolicyNumber: PropTypes.string.isRequired,
    isQuote: PropTypes.bool.isRequired,
    isPolicy: PropTypes.bool.isRequired,
    isPersonalAuto: PropTypes.bool,
    isPersonalUmbrella: PropTypes.bool,
    styles: PropTypes.arrayOf(PropTypes.shape({}))
};

MLRatingFactorPriorCarrierComponent.defaultProps = {
    isPersonalAuto: false,
    isPersonalUmbrella: false,
    styles: undefined
}

export default MLRatingFactorPriorCarrierComponent;